import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const SectionHeader = styled('h2')`
  ${(props) => props.theme.typography.largeStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin-top: 0;
  margin-bottom: 8px;

  body[data-theme] & {
    color: var(--s-color-text-softer);
  }

  ${media.lgUp`
    color: ${(props) => props.theme.color.white};
    body[data-theme] & {
      color: var(--s-color-text-solid);
    }
  `}
`;
